import clsx from 'clsx';
import { useContextSystem } from '../../context';
import styles from '../style.module.scss';
export function useCardMedia(props) {
  const {
    className,
    ...otherProps
  } = useContextSystem(props, 'CardMedia');
  const classes = clsx(styles.media,
  // This classname is added for legacy compatibility reasons.
  'components-card__media', className);
  return {
    ...otherProps,
    className: classes
  };
}